<template>
  <v-card
    class="rounded-lg pa-4"
    style="box-shadow: 0 0 30px 0 rgba(82, 63, 105, 0.05)"
  >
    <h3 class="card-title font-weight-bolder">
      {{
        $t("panelInfoProfile.panelTitle", {
          title: pack.title,
          days: persian(pack.expire),
        })
      }}
    </h3>

    <v-card-actions class="justify-center">
      <v-progress-circular
        :rotate="360"
        :size="100"
        :value="expire"
        :width="15"
        color="teal"
      >
        {{
          expire === "∞"
            ? expire
            : persian(expire) + $t("panelInfoProfile.percentage")
        }}
      </v-progress-circular>
    </v-card-actions>

    <v-card-text class="text-center">
      {{ $t("panelInfoProfile.buyOrRenew") }}
    </v-card-text>

    <v-btn block class="btn-buy d-flex align-center" to="/panel">{{
      $t("panelInfoProfile.buyPanel")
    }}</v-btn>
  </v-card>
</template>

<script>
import i18n from "@/i18n";

export default {
  name: "panelInfoProfile",
  i18n,
  data() {
    return {
      loading: false,
      pack: [],
      expire: null,
    };
  },
  mounted() {
    this.getPanel();
  },
  methods: {
    getPanel() {
      this.requestApiGet("currentPack").then((response) => {
        this.pack = response.data;
        let myDate = this.pack.expired_at;
        let pack_id = this.pack.id;
        this.fillExpire(myDate, pack_id);
      });
    },
    fillExpire(expire_date, pack_id) {
      if (
        !expire_date ||
        this.pack.expire >= 365 ||
        pack_id == 2 ||
        pack_id == 9
      ) {
        this.expire = "∞";
        return;
      }
      const expireDate = new Date(expire_date).getTime();
      let now = new Date().getTime();
      let diff = this.datediff(now, expireDate);
      if (diff >= 365) return (this.expire = "∞");
      this.expire = Math.max(
        Math.round(100 - ((this.pack.expire - diff) / this.pack.expire) * 100),
        0
      );
    },
  },
};
</script>

<style scoped></style>
